module.exports = __webpack_public_path__ + "img/alipay.c8f4b617.svg";